import { Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import {
  UpdateProfileAction,
  LogoutAction,
  AddItemToCart,
  RemoveItemFromCart,
  UpdateItemInCart,
  RemoveAllItemsFromCart,
  UpdateSelectedEventMonth, UpdateSelectedMerchantCategory, UpdateSelectedStoreCategory, UpdateSelectedNewsCategory
} from './app.actions';
import { ApplicationStateHandlers } from './app.state.handlers';
import { Observable } from 'rxjs';
import { CartItem } from './app.models';

@Injectable()
export class AppSandbox {
  @Select(ApplicationStateHandlers.profile)
  public profile$: Observable<any>;

  @Select(ApplicationStateHandlers.cart)
  public cart$: Observable<CartItem[]>;

  @Select(ApplicationStateHandlers.selectedEventMonth)
  public selectedEventMonth$: Observable<string>;

  @Select(ApplicationStateHandlers.selectedMerchantCategory)
  public selectedMerchantCategory$: Observable<string>;

  @Select(ApplicationStateHandlers.selectedMerchantSubCategory)
  public selectedMerchantSubCategory$: Observable<string>;

  @Select(ApplicationStateHandlers.selectedStoreCategory)
  public selectedStoreCategory$: Observable<string>;

  @Select(ApplicationStateHandlers.selectedNewsCategory)
  public selectedNewsCategory$: Observable<string>;

  constructor(private store: Store) {
  }

  updateProfile(profile: any): void {
    this.store.dispatch(new UpdateProfileAction(profile));
  }

  logout(): void {
    this.store.dispatch(new LogoutAction());
  }

  addProductToCart(item: CartItem): void {
    this.store.dispatch(new AddItemToCart(item));
  }

  removeItemFromCart(item: CartItem): void {
    this.store.dispatch(new RemoveItemFromCart(item));
  }

  removeAllItemsFromCart(): void {
    this.store.dispatch(new RemoveAllItemsFromCart());
  }

  updateItemInCart(item: CartItem, quantity: number): void {
    this.store.dispatch(new UpdateItemInCart(item, quantity));
  }

  updateSelectedEventMonth(month: string): void {
    this.store.dispatch(new UpdateSelectedEventMonth(month));
  }

  updateSelectedMerchantCategory(categoryName: string, subcategoryName: string): void {
    this.store.dispatch(new UpdateSelectedMerchantCategory(categoryName, subcategoryName));
  }

  updateSelectedStoreCategory(categoryName: string): void {
    this.store.dispatch(new UpdateSelectedStoreCategory(categoryName));
  }

  updateSelectedNewsCategory(categoryId: string): void {
    this.store.dispatch(new UpdateSelectedNewsCategory(categoryId));
  }

}
